var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51804 8.69321L12.0165 11.191L11.191 12.0165L8.69321 9.51804C7.76381 10.2631 6.60779 10.6683 5.41663 10.6666C2.51863 10.6666 0.166626 8.31463 0.166626 5.41663C0.166626 2.51863 2.51863 0.166626 5.41663 0.166626C8.31463 0.166626 10.6666 2.51863 10.6666 5.41663C10.6683 6.60779 10.2631 7.76381 9.51804 8.69321ZM8.34788 8.26038C9.08819 7.49906 9.50163 6.47854 9.49996 5.41663C9.49996 3.16029 7.67238 1.33329 5.41663 1.33329C3.16029 1.33329 1.33329 3.16029 1.33329 5.41663C1.33329 7.67238 3.16029 9.49996 5.41663 9.49996C6.47854 9.50163 7.49906 9.08819 8.26038 8.34788L8.34788 8.26038V8.26038Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.fbb7b200c65545ff26cf9a6010da7cbc.svg";
export { ForwardRef as ReactComponent };